<template>
    <div class="card flex justify-content-center">
        <Dialog ref="modal" v-model:visible="visible" modal :header="header_modal[lang].name"
            :style="{ width: '25rem' }">
            <span class="text-color-secondary block mb-3">
                {{ body_modal[lang].name }}
            </span>
            <div class="flex flex-column mb-3">
                <label for="username" class="w-full mb-2">
                    {{ input_name[lang].name }}
                </label>
                <InputText v-model="name" id="username" class="flex-auto h-3rem w-full" autocomplete="off" />
            </div>
            <div class="flex flex-column mb-3">
                <label for="number" class="w-full mb-2">
                    {{input_number[lang].name }}
                </label>
                <InputText v-model="tname" id="number" class="flex-auto h-3rem w-full" autocomplete="off" :useGrouping="false" />
            </div>
            <div class="flex justify-content-end gap-2">
                <Button type="button" :label="bt_cancel[lang].name" severity="secondary"
                    @click="cancel"></Button>
                <Button type="button" :label="bt_send[lang].name" @click="sendMessage"></Button>
            </div>
        </Dialog>
    </div>
</template>

<script setup>
    import { ref } from "vue";

    const visible = ref(false);
    function openModal() {
        visible.value = true;
    }
    defineExpose({
        openModal,
    });
</script>

<script>
import Connect from '@/assets/js/Connect'

export default {
    props: ['from'],
    data() {
        return {
            name: null,
            tname: null,
            visible: false,
            header_modal: {
                en: { name: "Feedback" },
                ru: { name: "Обратная связь" },
            },
            body_modal: {
                en: { name: "Fill in the blank fields." },
                ru: { name: "Заполните пустые поля." },
            },
            input_name: {
                en: { name: "Name" },
                ru: { name: "Имя" },
            },
            input_number: {
                en: { name: "Your telegram" },
                ru: { name: "Ваш телеграмм" },
            },
            bt_cancel: {
                en: { name: "Cancel" },
                ru: { name: "Отмена" },
            },
            bt_send: {
                en: { name: "Send" },
                ru: { name: "Отправить" },
            },
            content: {
                en: {
                    success: "Success",
                    error: "Error",
                    sent: "Message sent",
                    notsent: "Message not sent",
                },
                ru: {
                    success: "Успех",
                    error: "Ошибка",
                    sent: "Сообщение отправлено",
                    notsent: "Сообщение не отправлено",
                },
            }
        };
    },
    computed: {
        lang() {
            return this.$i18n.locale ? this.$i18n.locale : "ru";
        },
    },
    methods: {
        async sendMessage() {
            if(!this.name || !this.tname) {
                this.showMess('error', this.content[this.lang].error, this.content[this.lang].notsent)
                return false
            }
            const message = {
                name: this.name,
                fname: null,
                tname: this.tname
            }
            const from = (this.from) ? this.from : 'feedback'

            const send = await this.connect.sendMessage(message, from, []).then(res => res)
            console.log(send)
            if(send.result) {
                this.showMess('success', this.content[this.lang].success, this.content[this.lang].sent)
                this.cancel()
                return true
            } else {
                this.showMess('error', this.content[this.lang].error, this.content[this.lang].notsent)
                return false
            }
        },
        cancel() {
            // visible false
            console.log(this.$refs)
            this.$refs.modal.close()
            this.name = null;
            this.tname = null;
        },
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 1000 });
        },
    },
    beforeCreate() {
        this.connect = new Connect()
    },
};
</script>
